import { render, staticRenderFns } from "./NewDossier.vue?vue&type=template&id=e0215564&scoped=true&"
import script from "./NewDossier.vue?vue&type=script&lang=js&"
export * from "./NewDossier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0215564",
  null
  
)

export default component.exports